import { apiUrl } from "../../../../Constant/apiConstant"
import { getRequest, postJsonRequest } from "../../../../service/apiService"

//---------------------------------- offer letter api-------------------------------------------- 

export const getOfferLetter = async(tenant: string | undefined)=>{
    try{
        const response = await getRequest(apiUrl.CM_GET_OFFER_LETTER,{},tenant,true)

        if(response.status === 200){
            const {Status,Data} = response.data

            return Status ? Data : null
        }
    }catch(error){
        console.log(error)
    }
    return null
}


// ---------------------------------- add personal info custom field api--------------------------------------------
export const addPersonalInfoCustomField = async (payLoad: any, tenant: string | undefined) => {
    try {
        const response = await postJsonRequest(apiUrl.JM_ADD_PERSONAL_INFO_CUSTOM_FIELD, payLoad, tenant, true);

        if (response.status === 200) {
            const { Status, Message ,CustomFieldId,CreatedDate} = response.data;

            return {Status, Message,CustomFieldId,CreatedDate};   
        }
    } catch (error) {
        console.log(error);
    }
    return null;
};


export const getPersonalInfoCustomFields = async (tenant: string | undefined,isCandidate: boolean) => {
    try {
        const response = await getRequest(apiUrl.JM_GET_PERSONAL_INFO_CUSTOM_FIELDS, {}, tenant, true, isCandidate);

        if (response.status === 200) {
            const { Status, Data ,SectionNames} = response.data;

            return Status ? { Data: Data , SectionNames: SectionNames} : { Data: [] , SectionNames: [] };
        }
    } catch (error) {
        console.log(error);
    }
    return null
};

export const deletePersonalInfoCustomField = async (customFieldId: number, tenant: string | undefined) => {
    try {
        const response = await postJsonRequest(apiUrl.JM_DELETE_PERSONAL_INFO_CUSTOM_FIELD, { CustomFieldId: customFieldId }, tenant, true);

        if (response.status === 200) {
            const { Status, Message } = response.data;

            return { Status, Message };
        }
    } catch (error) {
        console.log(error);
    }
    return null;
};


// ---------------------------------hiring experience api--------------------------------------------

export const getHiringExperienceQuestions = async (tenant: string | undefined,payLoad:any,isCandidate: boolean)=>{
    try{
        const response =await postJsonRequest(apiUrl.JM_GET_ONBOARDING_QUESTIONS,payLoad,tenant,true,undefined,isCandidate)
        if(response.status === 200){
            const {Status,Data}=response.data

            return Status ? Data : null
        }
    }catch(error){
        console.log(error)
    }
    return null
}

export const addOrUpdateHiringExperienceQuestions = async (payLoad: any, tenant: string | undefined)=>{
    try{
        const response = await postJsonRequest(apiUrl.JM_POST_SAVE_ONBOARDING_QUESTIONS, payLoad, tenant, true)

        if(response.status === 200){
            const {Status, Message} = response.data

            return {Status, Message}
        }
    }catch(error){
        console.log(error)
    }
    return null
}

export const deleteHiringExperienceQuestion = async (questionNum: number, tenant: string | undefined) => {
    try {
        const response = await postJsonRequest(apiUrl.JM_POST_DELETE_ONBOARDING_QUESTION, { QuestionNum: questionNum }, tenant, true);

        if (response.status === 200) {
            const { Status, Message } = response.data;

            return { Status, Message };
        }
    } catch (error) {
        console.log(error);
    }
    return null;
};


//--------------------------documents api ----------------------------------------------------------

export const getDocumentsCustomFields=async (tenant: undefined | string)=>{
    try{
        const response = await getRequest(apiUrl.JM_GET_DOCUMENTS_CUSTOM_FIELDS,{},tenant,true)

        if(response.status === 200){
            const { Status, Data ,SectionNames} = response.data;

            return Status ? { Data: Data , SectionNames: SectionNames} : { Data: [] , SectionNames: [] };
        }
    }catch(error){
        console.log(error)
    }
    return null
}

export const addDocumentCustomField= async (payLoad:any,tenant:undefined | string)=>{
    try{
        const response = await postJsonRequest(apiUrl.JM_POST_ADD_DOCUMENTS_CUSTOM_FIELD,payLoad,tenant,true)

        if(response.status === 200){
            const { Status, Message ,CustomFieldId,CreatedDate} = response.data;

            return {Status, Message,CustomFieldId,CreatedDate};   

        }
    }catch(error){
        console.log(error)
    }
    return null
}

export const deleteDocumentCustomField = async (payLoad:any,tenant:string | undefined)=>{
    try{
        const response = await postJsonRequest(apiUrl.JM_POST_DELETE_DOCUMENT_CUSTOM_FIELD,payLoad,tenant,true)

        if(response.status === 200){
            const { Status, Message } = response.data;

            return { Status, Message };
        }
    }catch(error){
        console.log(error)
    }
    return null
}